import { render, staticRenderFns } from "./SettingDetails.vue?vue&type=template&id=aa661a74&"
import script from "./SettingDetails.vue?vue&type=script&lang=js&"
export * from "./SettingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports